const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.general.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllVenueOperatorsQueryOptions, getFindVenueCategoriesQueryOptions, getFindVenueQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/venues/$id/general')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindVenueQueryOptions(params.id));
    queryClient.ensureQueryData(getFindVenueCategoriesQueryOptions());
    queryClient.ensureQueryData(getFindAllVenueOperatorsQueryOptions());
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});